<template>
  <transition name="fade">
    <div v-if="loadingStore.isLoading" class="loading-overlay">
      <img src="@/assets/images/logo-azul.svg" alt="Carregando..." class="pulsing-logo" />
    </div>
  </transition>
</template>

<script setup>
import { useLoadingStore } from '@/stores/loading.js'
const loadingStore = useLoadingStore()
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-leave-to {
  opacity: 0;
}

.pulsing-logo {
  width: 150px;
  height: auto;
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
</style> 